import * as React from "react";

import { OneTimePasswordFieldSuggestionProvider } from "./one-time-password-password-field-suggestion-provider";
import { OneTimePasswordSendCodeFormProvider } from "./one-time-password-send-code-form-provider";
import {
  OneTimePasswordSendCodeProvider,
  OneTimePasswordSendCodeProviderProps,
} from "./one-time-password-send-code-provider";
import { OneTimePasswordUserExperienceFirstStepSendCodeProvider } from "./one-time-password-user-experience-first-step-send-code-provider";
import { OneTimePasswordUserExperienceProvider } from "./one-time-password-user-experience-provider";
import { OneTimePasswordUserExperienceSecondStepVerifyCodeProvider } from "./one-time-password-user-experience-second-step-verify-code-provider";
import {
  OneTimePasswordVerifyCodeFormProvider,
  OneTimePasswordVerifyCodeFormProviderProps,
} from "./one-time-password-verify-code-form-provider";

type OneTimePasswordProviderProps = OneTimePasswordVerifyCodeFormProviderProps &
  OneTimePasswordSendCodeProviderProps;

export const OneTimePasswordProvider: React.FunctionComponent<
  OneTimePasswordProviderProps
> = (props) => {
  return (
    <OneTimePasswordSendCodeProvider
      useInitialState={props.useInitialState}
      useAnalytics={props.useAnalytics}
    >
      <OneTimePasswordSendCodeFormProvider>
        <OneTimePasswordVerifyCodeFormProvider
          useInitialState={props.useInitialState}
        >
          <OneTimePasswordUserExperienceProvider>
            <OneTimePasswordUserExperienceFirstStepSendCodeProvider>
              <OneTimePasswordUserExperienceSecondStepVerifyCodeProvider>
                <OneTimePasswordFieldSuggestionProvider>
                  {props.children || []}
                </OneTimePasswordFieldSuggestionProvider>
              </OneTimePasswordUserExperienceSecondStepVerifyCodeProvider>
            </OneTimePasswordUserExperienceFirstStepSendCodeProvider>
          </OneTimePasswordUserExperienceProvider>
        </OneTimePasswordVerifyCodeFormProvider>
      </OneTimePasswordSendCodeFormProvider>
    </OneTimePasswordSendCodeProvider>
  );
};
